import { Component, Input } from '@angular/core';





@Component({
  selector: 'widget-datasource',
  templateUrl: 'widget-datasource.component.html',
  styleUrls: ['./widget-datasource.component.css']
})
export class WidgetDataSourceComponent {

  @Input()
  dataSource?: EveReportingWidgetDataSource = null;


  EveReportingWidgetDataSourceType = EveReportingWidgetDataSourceType;

}


export enum EveReportingWidgetDataSourceType {
  None,
  GraphQl,
  EveMultiChart,
  EveSingleChart
}


export interface EveReportingWidgetDataSource {
  type: EveReportingWidgetDataSourceType
}







